import { getDocumentList } from '@modusign/openapi-client-external-document';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useDebounce } from 'react-use';

import { SearchParams } from '@app/features/externalDocument/components/DocumentListPage/SearchFilter';
import workspaceService from '@app/libs/workspaceService';

const searchLimit = 5;

export default function useInstantSearch({
  enabled,
  filter,
  documentRegisteredFilter,
  keyword,
}: {
  keyword: string;
  enabled: boolean;
  documentRegisteredFilter: boolean;
  filter: SearchParams['filter'];
}) {
  const [debouncedKeyword, setDebouncedKeyword] = useState(keyword);

  useDebounce(
    () => {
      setDebouncedKeyword(keyword);
    },
    500,
    [keyword]
  );

  const documentResult = useQuery(
    ['externalDocumentInstantSearchDocument', debouncedKeyword, filter],
    () =>
      getDocumentList(workspaceService.getWorkspaceId(), {
        offset: 0,
        limit: searchLimit,
        orderBy: 'updatedAt:desc',
        q: debouncedKeyword,
        filter: {
          datesOfCompletion: filter.datesOfCompletion,
          documentPeriod: filter.documentPeriod,
          status: filter.status,
          labelId: filter.label?.id,
          isRegistered: documentRegisteredFilter ? true : undefined,
        },
        count: true,
      }),
    {
      cacheTime: 0,
      enabled: debouncedKeyword.length > 0 && enabled,
    }
  );

  return { ...documentResult, searchLimit, debouncedKeyword };
}
